import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+diffusion_model/+ud/table/dto_diffusion_models_table_page_settings_ud';
import { DTODiffusionModelsTableBase } from '@shared/dto/+diffusion_model/_base/table/dto_diffusion_model_table_base';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EPageDiffusionModelsFilterBaseModel } from '../enums/e_page_diffusion_models_filter_base_models';
import { DiffusionModelsFilterListBaseModelItem } from './diffusion_models_filter_list_base_model_item';

interface Props {
  on_item_selected: (value: string) => void;
  current_table: DTODiffusionModelsTableBase;
  current_table_page_settings: DTODiffusionModelsTablePageSettingsUD;
}

export function DiffusionModelsFilterListBaseModel({ on_item_selected, current_table, current_table_page_settings }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const [value_selected, set_value_selected] = useState(
    current_table_page_settings.is_filter_base_model_all() ? EPageDiffusionModelsFilterBaseModel.ALL : current_table_page_settings.filter_base_model,
  );

  /*
   * EVENTS
   */

  function on_value_change_internal(value: string) {
    set_value_selected(value);

    on_item_selected(value);
  }

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_items() {
    const items = Object.values(EPageDiffusionModelsFilterBaseModel);

    return items.map(item => {
      return (
        <DiffusionModelsFilterListBaseModelItem key={item} on_value_change={on_value_change_internal} {...{ value: item, value_selected, current_table }} />
      );
    });
  }

  /*
   * HTML
   */

  return (
    <div className="flex flex-col w-full h-full bg-component  overflow-hidden">
      <div className="min-h-[40px] px-2 flex items-center justify-start text-page-foreground bg-bar ">
        {t(i18n_page_diffusion_models.list.model_base.title)}
      </div>

      <div className="flex-grow overflow-y-auto pt-1 pb-1 px-2">{render_items()}</div>
    </div>
  );
}
